const stats = [
  { value: "120+", label: "精选影片" },
  { value: "10", label: "覆盖类型" },
  { value: "每周", label: "更新榜单" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50 pt-24 md:pt-28">
      <div className="pointer-events-none absolute -right-24 -top-10 h-72 w-72 rounded-full bg-primary-100/60 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-20 bottom-0 h-64 w-64 rounded-full bg-accent-100/50 blur-3xl"></div>

      <div className="relative mx-auto grid w-full max-w-[1200px] grid-cols-1 items-center gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-2 lg:gap-14">
        <div className="animate-fade-up">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 font-label text-xs font-medium text-primary-800">
            <i className="ri-award-line text-sm"></i>
            精选片单 · 每周更新
          </span>
          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-foreground-950 md:text-[42px] md:leading-[1.2]">
            风驰影院：帮你快速找到下一部值得看的电影
          </h1>
          <p className="mt-5 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
            这里把 <strong className="font-semibold text-foreground-900">必看片单、高分电影与热门作品</strong>
            整理在同一页。无论你是片荒随便翻翻，还是想精准避开烂片，都可以顺着榜单和类型快速锁定目标，
            省下翻评论的时间，直接进入观影状态。
          </p>

          <div className="mt-7 flex flex-wrap items-center gap-3">
            <a
              href="#must-watch"
              className="flex cursor-pointer items-center gap-2 rounded-md bg-primary-500 px-5 py-3 font-label text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line text-base"></i>
              查看本周必看榜
            </a>
            <a
              href="#genres"
              className="flex cursor-pointer items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-3 font-label text-sm font-medium text-foreground-800 whitespace-nowrap transition-colors hover:bg-background-100"
            >
              <i className="ri-filter-3-line text-base"></i>
              按类型找片
            </a>
          </div>

          <dl className="mt-10 grid max-w-md grid-cols-3 gap-4 border-t border-background-200 pt-6">
            {stats.map((item) => (
              <div key={item.label}>
                <dt className="font-heading text-2xl font-bold text-accent-600">
                  {item.value}
                </dt>
                <dd className="mt-1 font-label text-xs text-foreground-500">
                  {item.label}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative animate-fade-in">
          <div className="relative mx-auto w-full max-w-[440px] overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <div className="h-[380px] w-full md:h-[460px]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cozy%20independent%20cinema%20hall%20with%20rows%20of%20empty%20seats%20and%20glowing%20amber%20screen%20light%2C%20cinematic%20atmospheric%20interior%2C%20moody%20warm%20tones%2C%20film%20grain%2C%20high%20detail&width=700&height=900&seq=hero-cinema-hall-01&orientation=portrait"
                alt="温暖的独立影院放映厅场景"
                title="风驰影院 观影氛围"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-5">
              <p className="font-label text-xs text-background-200">今晚看什么？</p>
              <p className="mt-1 font-heading text-lg font-bold text-background-50">
                从高分到热门，一页看全
              </p>
            </div>
          </div>

          <div className="absolute -bottom-5 left-2 flex w-[230px] items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 shadow-none md:left-0">
            <div className="h-16 w-12 shrink-0 overflow-hidden rounded-md bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20animated%20movie%20poster%20art%20of%20a%20whimsical%20floating%20town%20above%20soft%20clouds%20with%20colorful%20balloons%20and%20warm%20sunset%20light%2C%20dreamy%20hand-painted%20style%2C%20gentle%20joyful%20mood%2C%20high%20detail&width=400&height=600&seq=movie-poster-animation-12&orientation=portrait"
                alt="云上小镇 电影海报"
                title="云上小镇 高分电影推荐"
                className="h-full w-full object-top object-cover"
              />
            </div>
            <div>
              <p className="font-label text-[11px] text-foreground-500">本周最高分</p>
              <p className="font-heading text-sm font-semibold text-foreground-950">云上小镇</p>
              <p className="mt-0.5 flex items-center gap-1 font-label text-xs text-accent-600">
                <i className="ri-star-fill text-[10px]"></i>
                9.3 · 动画
              </p>
            </div>
          </div>

          <div className="absolute -right-2 -top-4 hidden items-center gap-2 rounded-full border border-background-200 bg-background-50 px-3 py-2 md:flex">
            <i className="ri-emotion-happy-line text-primary-600"></i>
            <span className="font-label text-xs text-foreground-700">全家观影推荐</span>
          </div>
        </div>
      </div>
    </section>
  );
}